


























































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import ApiSimulador from "@/plugins/ApiSimulador";
import RdStation from "@/plugins/RdStation";
import CheckIcon from "vue-material-design-icons/Check.vue";
import CancelIcon from "vue-material-design-icons/Cancel.vue";

@Component({
  components: { CheckIcon, CancelIcon },
    computed:   {
        ...mapState(['cotacao']),
        ...mapGetters(['valor_mensalidade', 'veiculo_ano', 'get_email']),
    }
})
export default class Resumo extends Vue {
  public timeout = 0;

  public mounted() {
    this.$store.commit('SET_SIDEBAR_ENABLED', true);
    this.$store.commit("SET_SIDEBAR_SHOWING", this.$vuetify.breakpoint.smAndUp);
  }

  public beforeDestroy() {
     clearTimeout(this.timeout);
  }

  get protocolo() {
    return this.$store.state.cotacao.protocolo;
  }

  get preco() {
    return this.$store.getters.valor_fipe;
  }

  public sendInteresse ( interesse: boolean ) {
    const baseUrl = "//simulador.protruck.org.br/interesse";
    let pagina = '';

    let resposta = '';

    if (interesse) {
        resposta = 'Sim';
        pagina = "sim";
    } else {
        resposta = 'Não';
        pagina = "nao";
    }

    ApiSimulador.update({
      id: this.$store.state.cotacao.id,
      interesse: resposta,
    }).then(() => {
      RdStation.conversion({
        'identificador': `Interesse: ${resposta}` ,
        'Interesse em contratação': resposta,
        'email': this.$store.getters.get_email,
      }).then();
    });

    window.location.href = `${baseUrl}/${pagina}.php?id=${this.protocolo}`;
  }
}
